import { queryOptions } from '@tanstack/react-query';
import type { OrganizerBlockDto } from '@upme/contracts';
import { api } from '../../app/api-client';

export const organizerBlocksKey = ['admin', 'organizer-blocks'] as const;

export const organizerBlocksOptions = () =>
  queryOptions({
    queryKey: [...organizerBlocksKey],
    queryFn: () => api.get('admin/organizer-blocks').json<OrganizerBlockDto[]>(),
  });
